"use strict";

($dt => {

	const { STRIPE } = $dt.TopicGrid.Constants;
	const { on_nothing, apply_form_validation_to_summary } = $dt.TopicGrid.Functions;

	const is_payment_status_valid = status => {
		return status === 'requires_capture' || status === 'succeeded';
	};

	/**
	 * Deposit Payment Collection
	 * 
	 * @param {Block} block 
	 * @param {InnerScreen} inner_screen 
	 * @param {*} controller 
	 */
	$dt.TopicGrid.ScreenFunctions.o2_i1 = (block, inner_screen, controller) => {
		const { inner_elem } = inner_screen;
		const [ button_next_elem, button_prev_elem, payment_wrapper_elem, skip_payment_elem, skip_payment_button, address_wrapper_elem ] = [
			inner_elem.querySelector('.button-next'),
			inner_elem.querySelector('.button-prev'),
			inner_elem.querySelector('.payment-wrapper'),
			inner_elem.querySelector('.skip-payment'),
			inner_elem.querySelector('.button-skip-processing'),
			inner_elem.querySelector('.address-wrapper'),
		];
		let paymentIntentStatus = null;
		let requestSkipPayment = false;

		button_prev_elem.addEventListener('click', () => {
			const { current_screen } = block;
			current_screen.outer = 2;
			current_screen.inner = 0;
			controller.SetScreenUI(block);
		});

		$dt.OnDevelformsReady($df => {
			$df.RegisterFormPreparedEvent('eglxyorder', form => {
				const submit_form = () => {
					const { scheduling_info, d3df_page_options, current_screen } = block;

					// Submit final form processing
					form.currentContainer = inner_elem; // setting this for the error summary for API issues
					const data = {};

					if (requestSkipPayment) {
						data.request_skip_payment = 'Yes';
					}

					// Known scheduling info for progressive form saving
					controller.SetSchedulingFormData(block, data);

					// Contact Info if Anonymous
					controller.SetContactInfoFormData(block, data);

					const on_complete = () => {
						controller.EndWaiting(block);
					};

					const on_validation_error = errors => {
						controller.FormValidationFailed(form, errors);
					};

					const on_success = resp => {
						// Save contact info
						scheduling_info.order_id = resp.entity.egalaxy_order_id.value;

						// Reset answers to questions
						scheduling_info.class_info_questions = [];

						// Transition Screen							
						current_screen.outer = 0;
						current_screen.inner = 7;

						controller.SetScreenUI(block);
					};

					// Update page options
					d3df_page_options.pageIndex = false; // final submit
					d3df_page_options.onSuccess = on_success;

					// Send to server for finalization
					form.submit(data, on_success, on_validation_error, on_nothing, on_complete, d3df_page_options);
				};

				const next_button_click = () => {
					const { stripe_elements } = block;
					if (stripe_elements) {
						// Start waiter
						controller.StartWaiting(block);

						// Check if payment processed already
						if (is_payment_status_valid(paymentIntentStatus)) {
							submit_form();
						} else {
							// Process Payment
							const stripe = $dt.Stripe;
							stripe.confirmPayment(null, true)
								.then(result => {
									const { error, paymentIntent } = result;
									if (error) {
										// Validation issues, stripe will present its form issues
										switch (error.code) {
											case "expired_card":
											case "incorrect_cvc":
											case "card_declined":
												apply_form_validation_to_summary(inner_elem, form, [
													{
														Key: 'stripe',
														Message: 'Payment could not be authorized. Please use another card or click the "Pay Later" button below to complete the transaction and we will contact you for payment.'
													}
												]);

												// Offer skip payment
												skip_payment_elem.classList.add('option-available');
												skip_payment_button.removeAttribute('disabled');
												break;
											case "processing_error":
												apply_form_validation_to_summary(inner_elem, form, [
													{
														Key: 'stripe',
														Message: 'An unexpected processing error occurred.'
													}
												]);
												break;
											case "incorrect_number":
											default:
												// These should be handled by payment element
												// https://docs.stripe.com/error-codes#card-declined
												break;
										}

										// End waiter
										controller.EndWaiting(block);
									} else {
										// If user has not been redirected, so we can attempt to complete the process
										if (paymentIntent) {
											if (is_payment_status_valid(paymentIntent.status)) {
												// We're ready to complete this order
												paymentIntentStatus = paymentIntent.status;
												submit_form();
											} else {
												// Some other status (we want this to be an error)
												apply_form_validation_to_summary(inner_elem, form, [
													{
														Key: 'stripe',
														Message: 'An unexpected processing error occurred.'
													}
												]);

												// End waiter
												controller.EndWaiting(block);
											}	
										} else {
											// Other unexpected issue
											apply_form_validation_to_summary(inner_elem, form, [
												{
													Key: 'stripe',
													Message: 'An unexpected processing error occurred.'
												}
											]);

											// End waiter
											controller.EndWaiting(block);
										}
									}
								})
								.catch(() => {
									// Unexpected error, stripe has no documentation on this
									controller.EndWaiting(block);
								});
						}
					}
				};

				const skip_payment_click = () => {
					requestSkipPayment = true;
					controller.StartWaiting(block);
					submit_form();
				};

				// Next / attempt payment
				button_next_elem.addEventListener('click', $dt.Util.debounce(next_button_click, $df.debounceThreshold));

				// Skip payment if failed
				skip_payment_button.addEventListener('click', $dt.Util.debounce(skip_payment_click, $df.debounceThreshold));
			});
		});

		// Field prepopulators
		inner_screen.Show = () => {
			const { stripe_elements } = block;
			button_next_elem.setAttribute('disabled', '');
			payment_wrapper_elem.innerHTML = '';

			// Reset skip payment
			requestSkipPayment = false;
			skip_payment_elem.classList.remove('option-available');
			skip_payment_button.setAttribute('disabled', '');

			if (stripe_elements) {
				paymentIntentStatus = null;
				const payment_element = stripe_elements.getElement('payment');
				payment_element.mount(payment_wrapper_elem);

				if (STRIPE.address) {
					const address_element = stripe_elements.getElement('address');
					address_element.mount(address_wrapper_elem);
				}

				button_next_elem.removeAttribute('disabled');
			} else {
				console.warn('Stripe payment element not found.');
			}
		};
	};

})(window.d3_wp_themejs);
